import { render, staticRenderFns } from "./Registered.vue?vue&type=template&id=2af6b201"
import script from "./Registered.vue?vue&type=script&lang=ts"
export * from "./Registered.vue?vue&type=script&lang=ts"
import style0 from "./Registered.vue?vue&type=style&index=0&id=2af6b201&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports